// AUTO-GENERATED from design/tokens.json — run "npm run tokens:generate". Do not edit.

export const COLOR = {
  "primary": {
    "50": "#fff7ed",
    "100": "#ffedd5",
    "200": "#fed7aa",
    "300": "#fdba74",
    "400": "#fb923c",
    "500": "#f97316",
    "600": "#ea580c",
    "700": "#c2410c",
    "800": "#9a3412",
    "900": "#7c2d12",
    "950": "#431407"
  },
  "secondary": {
    "50": "#f8fafc",
    "100": "#f1f5f9",
    "200": "#e2e8f0",
    "300": "#cbd5e1",
    "400": "#94a3b8",
    "500": "#64748b",
    "600": "#475569",
    "700": "#334155",
    "800": "#1e293b",
    "900": "#0f172a",
    "950": "#020617"
  },
  "accent": {
    "50": "#fffbeb",
    "100": "#fef3c7",
    "200": "#fde68a",
    "300": "#fcd34d",
    "400": "#fbbf24",
    "500": "#f59e0b",
    "600": "#d97706",
    "700": "#b45309",
    "800": "#92400e",
    "900": "#78350f",
    "950": "#451a03"
  },
  "success": {
    "50": "#f0fdf4",
    "100": "#dcfce7",
    "200": "#bbf7d0",
    "300": "#86efac",
    "400": "#4ade80",
    "500": "#22c55e",
    "600": "#16a34a",
    "700": "#15803d",
    "800": "#166534",
    "900": "#14532d",
    "950": "#052e16"
  },
  "warning": {
    "50": "#fffbeb",
    "100": "#fef3c7",
    "200": "#fde68a",
    "300": "#fcd34d",
    "400": "#fbbf24",
    "500": "#f59e0b",
    "600": "#d97706",
    "700": "#b45309",
    "800": "#92400e",
    "900": "#78350f",
    "950": "#451a03"
  },
  "error": {
    "50": "#fef2f2",
    "100": "#fee2e2",
    "200": "#fecaca",
    "300": "#fca5a5",
    "400": "#f87171",
    "500": "#ef4444",
    "600": "#dc2626",
    "700": "#b91c1c",
    "800": "#991b1b",
    "900": "#7f1d1d",
    "950": "#450a0a"
  }
};

export const FONT_FAMILY = {
  "sans": [
    "Manrope",
    "system-ui",
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "sans-serif"
  ],
  "display": [
    "Bricolage Grotesque",
    "Manrope",
    "system-ui",
    "sans-serif"
  ],
  "mono": [
    "Ubuntu Mono",
    "Monaco",
    "Cascadia Code",
    "Segoe UI Mono",
    "Roboto Mono",
    "monospace"
  ]
};

export const TRACKING = {
  "display": "-0.022em",
  "displaySmall": "-0.012em"
};

export const RADIUS = {
  "sm": {
    "value": "0.75rem",
    "class": "rounded-xl"
  },
  "md": {
    "value": "1rem",
    "class": "rounded-2xl"
  },
  "lg": {
    "value": "1.5rem",
    "class": "rounded-3xl"
  },
  "4xl": {
    "value": "2rem",
    "class": "rounded-4xl"
  },
  "5xl": {
    "value": "2.5rem",
    "class": "rounded-5xl"
  }
};

export const DURATION = {
  "press": 0.14,
  "hover": 0.16,
  "popover": 0.2,
  "exit": 0.18,
  "modal": 0.28,
  "fast": 0.18,
  "normal": 0.32,
  "slow": 0.48
};

export const EASING = {
  "entrance": [
    0.23,
    1,
    0.32,
    1
  ],
  "smooth": [
    0.22,
    1,
    0.36,
    1
  ],
  "exit": [
    0.4,
    0,
    0.2,
    1
  ],
  "out": [
    0.23,
    1,
    0.32,
    1
  ],
  "inOut": [
    0.77,
    0,
    0.175,
    1
  ],
  "drawer": [
    0.32,
    0.72,
    0,
    1
  ]
};

export const Z_INDEX = {
  "topbar": 9990,
  "sidebar-overlay": 9998,
  "sidebar": 9999,
  "modal": 10000,
  "topbar-menu": 10019,
  "dropdown": 10020,
  "qrcode": 10040,
  "lightbox": 10050,
  "skip": 10060
};

export const EASING_CSS = {
  entrance: 'cubic-bezier(0.23, 1, 0.32, 1)',
  smooth: 'cubic-bezier(0.22, 1, 0.36, 1)',
  exit: 'cubic-bezier(0.4, 0, 0.2, 1)',
  out: 'cubic-bezier(0.23, 1, 0.32, 1)',
  inOut: 'cubic-bezier(0.77, 0, 0.175, 1)',
  drawer: 'cubic-bezier(0.32, 0.72, 0, 1)',
};

export const DURATION_CSS = {
  press: '140ms',
  hover: '160ms',
  popover: '200ms',
  exit: '180ms',
  modal: '280ms',
  fast: '180ms',
  normal: '320ms',
  slow: '480ms',
};
